<template>
    <van-overlay :show="value" z-index="3000" :lock-scroll="true">
        <div class="dest_map_popup" v-if="value" @click.stop>
            <div class="dest_map_header">
                <span class="dest_map_title">确认目的地</span>
                <div class="dest_map_close" @click="close">
                    <van-icon name="cross" color="#1F2129" size="18" />
                </div>
            </div>
            <div class="dest_map_search">
                <van-field
                    v-model="keyword"
                    placeholder="搜索位置"
                    clearable
                    @input="onSearchChange"
                    @clear="clearSearch" />
            </div>
            <div class="dest_map_tips" v-if="tipsList.length">
                <div
                    class="dest_map_tip_item"
                    v-for="(item, index) in tipsList"
                    :key="index"
                    @click="selectTip(item)">
                    <div class="dest_map_tip_name">{{ item.name }}</div>
                    <div class="dest_map_tip_addr">{{ tipAddress(item) }}</div>
                </div>
            </div>
            <div class="dest_map_wrap">
                <div v-show="hasLocation" ref="destMapEl" class="dest_map"></div>
                <div v-if="!hasLocation" class="dest_map_empty">
                    <span class="dest_map_empty_text">请搜索并选择目的地</span>
                </div>
            </div>
            <div class="dest_map_address">
                <div class="dest_map_address_label">当前选择</div>
                <div class="dest_map_address_text">{{ selectedAddress || '请选择位置' }}</div>
            </div>
            <div class="dest_map_footer">
                <div class="dest_map_btn dest_map_btn_cancel" @click="close">
                    <span class="dest_map_btn_cancel_text">取消</span>
                </div>
                <div class="dest_map_btn dest_map_btn_confirm" @click="confirm">
                    <span class="dest_map_btn_confirm_text">确认</span>
                </div>
            </div>
        </div>
    </van-overlay>
</template>

<script>
import { Toast } from 'vant';
import {
    resolveAddressLocation,
    searchInputTips,
    regeoLocation,
    isValidPoint,
    parseLngLat
} from '@/utils/amapLocation.js';

export default {
    name: 'destinationMapPopup',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        orderInfo: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            keyword: '',
            tipsList: [],
            searchTimer: null,
            latitude: 0,
            longitude: 0,
            selectedAddress: '',
            hasLocation: false,
            movingBySelect: false,
            ignoreSearchChange: false,
            map: null,
            marker: null,
            pinIcon: require('@/assets/rescueImgs/marker_end.png')
        };
    },
    watch: {
        value(val) {
            if (val) {
                this.$nextTick(() => {
                    this.initDefaultLocation();
                });
            } else {
                this.destroyMap();
                this.resetState();
            }
        }
    },
    beforeDestroy() {
        this.clearSearchTimer();
        this.destroyMap();
    },
    methods: {
        resetState() {
            Toast.clear();
            this.clearSearchTimer();
            this.keyword = '';
            this.tipsList = [];
            this.latitude = 0;
            this.longitude = 0;
            this.selectedAddress = '';
            this.hasLocation = false;
            this.movingBySelect = false;
            this.ignoreSearchChange = false;
        },
        clearSearchTimer() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
                this.searchTimer = null;
            }
        },
        tipAddress(item) {
            if (item.address && typeof item.address === 'string') {
                return item.district ? (item.district + item.address) : item.address;
            }
            return item.district || '';
        },
        destroyMap() {
            if (this.map) {
                this.map.destroy();
                this.map = null;
            }
            this.marker = null;
        },
        ensureMap() {
            if (this.map || !this.hasLocation || !this.$refs.destMapEl || !window.AMap) return;
            this.map = new window.AMap.Map(this.$refs.destMapEl, {
                zoom: 16,
                center: [this.longitude, this.latitude],
                resizeEnable: true
            });
            this.marker = new window.AMap.Marker({
                position: [this.longitude, this.latitude],
                icon: new window.AMap.Icon({
                    size: new window.AMap.Size(26, 38),
                    image: this.pinIcon,
                    imageSize: new window.AMap.Size(26, 38)
                }),
                offset: new window.AMap.Pixel(-13, -38)
            });
            this.map.add(this.marker);
            this.map.on('click', this.onMapTap);
            this.map.on('dragend', this.onMapDragEnd);
            this.$nextTick(() => {
                if (this.map) this.map.resize();
                setTimeout(() => {
                    if (this.map) this.map.resize();
                }, 200);
            });
        },
        updateMarker(lng, lat) {
            if (!this.marker) return;
            this.marker.setPosition([Number(lng), Number(lat)]);
        },
        setMapLocation(lng, lat) {
            lng = Number(lng);
            lat = Number(lat);
            if (!isValidPoint(lng, lat)) return false;
            this.movingBySelect = true;
            this.hasLocation = true;
            this.longitude = lng;
            this.latitude = lat;
            this.$nextTick(() => {
                if (!this.map) {
                    this.ensureMap();
                } else {
                    this.map.setZoomAndCenter(16, [lng, lat]);
                    this.updateMarker(lng, lat);
                }
                setTimeout(() => {
                    this.movingBySelect = false;
                }, 500);
            });
            return true;
        },
        async initDefaultLocation() {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                overlay: true,
                duration: 0
            });
            let orderInfo = (this.orderInfo && typeof this.orderInfo === 'object') ? this.orderInfo : {};
            let originAddress = (orderInfo.destination || '').trim();
            let lng = 0;
            let lat = 0;

            let transitPoint = parseLngLat(orderInfo.transit);
            if (transitPoint) {
                lng = transitPoint.lng;
                lat = transitPoint.lat;
            }

            if (!isValidPoint(lng, lat) && originAddress) {
                let resolved = await resolveAddressLocation(originAddress, orderInfo.d_city);
                if (resolved && resolved.ok) {
                    lng = Number(resolved.lng);
                    lat = Number(resolved.lat);
                }
            }

            Toast.clear();
            this.selectedAddress = originAddress;

            if (isValidPoint(lng, lat)) {
                this.setMapLocation(lng, lat);
                return;
            }

            Toast('无法定位默认目的地，请搜索选择');
            this.hasLocation = false;
        },
        async updateAddressByPoint(lng, lat) {
            let loc = await regeoLocation({ lng, lat });
            if (loc && loc.address) {
                this.selectedAddress = loc.address;
            }
        },
        onSearchChange(val) {
            let keyword = typeof val === 'string' ? val : this.keyword;
            this.keyword = keyword;
            this.clearSearchTimer();
            if (this.ignoreSearchChange || this.movingBySelect) {
                return;
            }
            if (!keyword) {
                this.tipsList = [];
                return;
            }
            this.searchTimer = setTimeout(() => {
                this.doSearch(keyword);
            }, 350);
        },
        async doSearch(keyword) {
            if (this.ignoreSearchChange || this.movingBySelect) return;
            let requestKeyword = keyword;
            let location = this.longitude && this.latitude
                ? `${this.longitude},${this.latitude}`
                : '';
            let tips = await searchInputTips(requestKeyword, location);
            if (this.ignoreSearchChange || this.movingBySelect) return;
            if (this.keyword !== requestKeyword) return;
            this.tipsList = tips;
        },
        clearSearch() {
            this.clearSearchTimer();
            this.ignoreSearchChange = true;
            this.keyword = '';
            this.tipsList = [];
            this.$nextTick(() => {
                this.ignoreSearchChange = false;
            });
        },
        selectTip(item) {
            let point = parseLngLat(item && item.location);
            if (!point) {
                Toast('该地址无有效坐标');
                return;
            }
            this.clearSearchTimer();
            this.ignoreSearchChange = true;
            this.tipsList = [];
            this.selectedAddress = item.name
                ? (this.tipAddress(item) ? `${item.name}(${this.tipAddress(item)})` : item.name)
                : (this.tipAddress(item) || item.name);
            this.keyword = item.name || '';
            this.setMapLocation(point.lng, point.lat);
            setTimeout(() => {
                this.ignoreSearchChange = false;
            }, 800);
        },
        onMapTap(e) {
            if (!e || !e.lnglat) return;
            let lng = Number(e.lnglat.lng);
            let lat = Number(e.lnglat.lat);
            if (!this.setMapLocation(lng, lat)) return;
            this.updateAddressByPoint(lng, lat);
        },
        onMapDragEnd() {
            if (this.movingBySelect || this.tipsList.length || !this.map) return;
            let center = this.map.getCenter();
            if (!center) return;
            let lng = Number(center.lng);
            let lat = Number(center.lat);
            if (!isValidPoint(lng, lat)) return;
            this.hasLocation = true;
            this.longitude = lng;
            this.latitude = lat;
            this.updateMarker(lng, lat);
            this.updateAddressByPoint(lng, lat);
        },
        close() {
            this.$emit('input', false);
            this.$emit('close');
        },
        confirm() {
            if (!this.hasLocation || !isValidPoint(this.longitude, this.latitude)) {
                Toast('请选择目的地位置');
                return;
            }
            if (!this.selectedAddress) {
                Toast('请选择目的地地址');
                return;
            }
            this.$emit('confirm', {
                actual_address: this.selectedAddress,
                actual_point: `${this.longitude},${this.latitude}`
            });
            this.$emit('input', false);
        }
    }
};
</script>

<style lang="scss" scoped>
.dest_map_popup {
    position: absolute;
    left: 4%;
    right: 4%;
    top: 10%;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-sizing: border-box;
}
.dest_map_header {
    height: 48px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.dest_map_title {
    font-size: 16px;
    color: #1F2129;
    font-weight: 600;
}
.dest_map_close {
    padding: 6px;
}
.dest_map_search {
    margin: 0 12px 8px;
    background: #F5F6F8;
    border-radius: 6px;
    overflow: hidden;
}
.dest_map_search ::v-deep .van-field {
    background: #F5F6F8;
    padding: 6px 12px;
}
.dest_map_tips {
    max-height: 140px;
    overflow-y: auto;
    margin: 0 12px 8px;
    background: #F8F9FB;
    border-radius: 6px;
}
.dest_map_tip_item {
    padding: 10px 12px;
    border-bottom: 1px solid #ECEEF2;
}
.dest_map_tip_item:last-child {
    border-bottom: 0;
}
.dest_map_tip_name {
    font-size: 14px;
    color: #1F2129;
    margin-bottom: 4px;
}
.dest_map_tip_addr {
    font-size: 12px;
    color: #8A8F99;
    line-height: 16px;
}
.dest_map_wrap {
    position: relative;
    margin: 0 12px;
    height: 210px;
    border-radius: 6px;
    overflow: hidden;
}
.dest_map {
    width: 100%;
    height: 100%;
}
.dest_map_empty {
    width: 100%;
    height: 100%;
    background: #F5F6F8;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dest_map_empty_text {
    font-size: 14px;
    color: #8A8F99;
}
.dest_map_address {
    padding: 10px 16px 4px;
}
.dest_map_address_label {
    font-size: 12px;
    color: #8A8F99;
    margin-bottom: 4px;
}
.dest_map_address_text {
    font-size: 14px;
    color: #1F2129;
    line-height: 20px;
}
.dest_map_footer {
    display: flex;
    justify-content: space-between;
    padding: 12px 16px 20px;
}
.dest_map_btn {
    width: 48%;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.dest_map_btn_cancel {
    background: #ffffff;
    border: 1px solid #357EFE;
}
.dest_map_btn_cancel_text {
    font-size: 15px;
    color: #357EFE;
}
.dest_map_btn_confirm {
    background: linear-gradient(90deg, #357EFE, #5B9BFF);
}
.dest_map_btn_confirm_text {
    font-size: 15px;
    color: #ffffff;
}
</style>
